import $ from 'jquery';
import wishlist from 'modules/wishlist';

$(function() {
    wishlist.checkWihlistTagId();
    wishlist.bindWishListEvent();
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/lp/index.js